'use client'

import React, { createContext, useCallback, useContext, useState } from 'react'

import { NewsCarouselModal } from '@/components/news-carousel-modal'

type NewsModalContextType = {
  openModal: () => void
  closeModal: () => void
}

const NewsModalContext = createContext<NewsModalContextType | undefined>(undefined)

export function NewsModalProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false)

  const openModal = useCallback(() => setOpen(true), [])
  const closeModal = useCallback(() => setOpen(false), [])

  return (
    <NewsModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <NewsCarouselModal open={open} onOpenChange={setOpen} />
    </NewsModalContext.Provider>
  )
}

export function useNewsModal() {
  const ctx = useContext(NewsModalContext)
  if (ctx === undefined) {
    throw new Error('useNewsModal must be used within NewsModalProvider')
  }
  return ctx
}
